import { Box } from '@mui/material';

const ONBOARDING_ASSETS_BASE = '/assets/onboarding';

export const ONBOARDING_TRAINING_PLAN_READY_SRC = `${ONBOARDING_ASSETS_BASE}/training-plan-ready.png`;
export const ONBOARDING_TRAINING_PLAN_READY_SRC_2X = `${ONBOARDING_ASSETS_BASE}/training-plan-ready@2x.png`;
export const ONBOARDING_AI_SPARKLE_ICON_SRC = `${ONBOARDING_ASSETS_BASE}/ai-sparkle-icon.png`;
export const ONBOARDING_AI_SPARKLE_ICON_SRC_2X = `${ONBOARDING_ASSETS_BASE}/ai-sparkle-icon@2x.png`;

interface OnboardingRetinaImageProps {
  src: string;
  src2x: string;
  width: number | string;
  height: number | string;
  alt?: string;
  sx?: Record<string, unknown>;
}

/** Figma-exported PNG with @2x srcSet for retina displays. */
export function OnboardingRetinaImage({
  src,
  src2x,
  width,
  height,
  alt = '',
  sx,
}: OnboardingRetinaImageProps) {
  return (
    <Box
      component="img"
      src={src}
      srcSet={`${src} 1x, ${src2x} 2x`}
      alt={alt}
      width={width}
      height={height}
      decoding="async"
      draggable={false}
      sx={{
        width,
        height,
        display: 'block',
        flexShrink: 0,
        objectFit: 'contain',
        objectPosition: 'center',
        ...sx,
      }}
    />
  );
}
